import { render, staticRenderFns } from "./edit-partner-business-profile-form.vue?vue&type=template&id=458882c6&"
import script from "./edit-partner-business-profile-form.vue?vue&type=script&lang=js&"
export * from "./edit-partner-business-profile-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports